/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type Prerequisite = {
  key: string;
  variation: number;
};

/** @internal */
export const Prerequisite$inboundSchema: z.ZodType<
  Prerequisite,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  variation: z.number().int(),
});
/** @internal */
export type Prerequisite$Outbound = {
  key: string;
  variation: number;
};

/** @internal */
export const Prerequisite$outboundSchema: z.ZodType<
  Prerequisite$Outbound,
  z.ZodTypeDef,
  Prerequisite
> = z.object({
  key: z.string(),
  variation: z.number().int(),
});

export function prerequisiteToJSON(prerequisite: Prerequisite): string {
  return JSON.stringify(Prerequisite$outboundSchema.parse(prerequisite));
}
export function prerequisiteFromJSON(
  jsonString: string,
): SafeParseResult<Prerequisite, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Prerequisite$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Prerequisite' from JSON`,
  );
}
